var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLegalBasisIcon = function SvgLegalBasisIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 42 42"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    fill: "#fff",
    rx: 21
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#C12C50",
    d: "M33.387 32.66c0 .402-.325.727-.726.727H22.016a.726.726 0 1 1 0-1.452h.242v-2.177c0-.401.325-.726.726-.726h8.71c.4 0 .725.325.725.726v2.177h.242c.4 0 .726.325.726.726ZM22.99 26.916c.516.614 1.431.694 2.045.179l7.043-5.91a1.452 1.452 0 0 0-1.867-2.223L23.17 24.87a1.452 1.452 0 0 0-.179 2.045Zm.87-17.783a1.452 1.452 0 0 0-2.046-.18l-7.042 5.91a1.452 1.452 0 0 0 1.866 2.224l7.042-5.91c.614-.514.694-1.43.18-2.044Zm-6.157 11.482-1.112.933 2.177 2.594 1.112-.933-2.177-2.594Zm-2.316 1.756-5.83 4.277a2.312 2.312 0 1 0 2.967 3.535l5.224-4.997-2.361-2.815Zm2.184-4.172 4.665 5.56 7.043-5.91-4.666-5.56-7.042 5.91Z"
  })));
};
export default SvgLegalBasisIcon;